<template>
  <v-row class="my-4" no-gutters>
    <v-col>
      <AdminInputCheckbox
        :Model="Model"
        :id="id"
        :field-name="fieldName"
        size="x-large"
        @click="toggle"
        :on="on"
        v-bind="{ ...$attrs, ...$props }"
      />
      <span class="ml-2">{{ label }}</span>
    </v-col>
  </v-row>
</template>

<script>
import AdminInputCheckbox from '@/components/AdminInputCheckbox'
import _get from 'lodash/get'

import { Model } from '@vuex-orm/core'
export default {
  name: 'AdminFieldCheckbox',
  components: { AdminInputCheckbox },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    fieldName: {
      type: String,
      default: '',
    },
  },
  computed: {
    on() {
      return _get(this.Model.find(this.id), this.fieldName, false)
    },
  },
  methods: {
    async toggle() {
      if ('function' === typeof this.Model.updateModel) {
        const fields = { [this.fieldName]: !this.on }
        this.disabled = true
        try {
          await this.Model.update({ where: this.id, data: fields })
          this.error = false
        } catch (error) {
          this.error = true
        } finally {
          this.disabled = false
        }
      }
    }, // toggle
  },
}
</script>
